import { type MarkType, Node } from '@tiptap/pm/model';
import { Range } from '@tiptap/core';
import { getMarksBetween } from '@tiptap/react';

function getMarksOfTypeTouchedByRange(
  document: Node,
  selection: { from: number; to: number },
  type: MarkType
) {
  return getMarksBetween(selection.from, selection.to, document).filter(
    markAndPos => markAndPos.mark.type.name === type.name
  );
}

/**
 * Checks if the document has content to the right of the supplied range.
 */
function hasContentRightOfRange(document: Node, range: Range) {
  try {
    // prosemirror doesn't offer a function that doesn't error when trying to access content beyond bounds,
    // so we have to do this hacky try/catch approach. We could try to look at document.nodeSize, but I've found
    // that to be off. Probably my own misunderstanding of what that value means. Even when the document is empty, that
    // nodeSize is > 0.
    //
    // Anyways, here we are.
    document.nodeAt(range.to + 1);
    return true;
  } catch {
    return false;
  }
}

/**
 * Why pad the range? Because some input cases may affect hashtags on either side of the range. e.g. deleting a space
 * between valid hashtag text and an existing hashtag.
 */
export function getMarksOfTypeTouchedByPaddedRange(
  document: Node,
  range: Range,
  type: MarkType
) {
  return getMarksOfTypeTouchedByRange(
    document,
    {
      // We're padding the range a bit here to make sure we pick up any hashtags when the user
      // has a zero-length selection (i.e. just a cursor)
      from: range.from > 1 ? range.from - 1 : range.from,
      to: hasContentRightOfRange(document, range) ? range.to + 1 : range.to,
    },
    type
  );
}
